import { Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, Paper, LinearProgress } from '@mui/material';
import { useProjectExpenses, useProjectRollup } from '../../hooks/useProjects';
import { BarList } from './RollupCards';
import { formatMoneyFull } from './constants';

export default function ExpensesTab({ projectId, scope }) {
  const { data: entries = [], isLoading } = useProjectExpenses(projectId, scope);
  const { data: rollup } = useProjectRollup(projectId, scope);

  return (
    <Box>
      <BarList
        title="By category"
        rows={(rollup?.expenses_by_category || []).map((r) => ({ label: r.category || '(uncategorized)', value: r.amount }))}
        valueFormat={formatMoneyFull}
      />
      <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
        <Box sx={{ p: 1.5, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="subtitle2">Expenses ({entries.length})</Typography>
          <Typography variant="caption" color="text.secondary">
            Total: {formatMoneyFull(rollup?.expenses_total || 0)}
          </Typography>
        </Box>
        {isLoading && <LinearProgress />}
        {!isLoading && entries.length === 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ p: 3, textAlign: 'center' }}>
            No expenses logged for this project yet.
          </Typography>
        )}
        {entries.length > 0 && (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>Person</TableCell>
                <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>Project</TableCell>
                <TableCell>Category</TableCell>
                <TableCell align="right">Amount</TableCell>
                <TableCell>Memo</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {entries.map((e) => (
                <TableRow key={e.id} hover>
                  <TableCell>{e.date ? String(e.date).slice(0, 10) : '—'}</TableCell>
                  <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>{e.person || '—'}</TableCell>
                  <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>{e.project_name || '—'}</TableCell>
                  <TableCell>{e.category || '—'}</TableCell>
                  <TableCell align="right" sx={{ fontVariantNumeric: 'tabular-nums' }}>{formatMoneyFull(e.amount)}</TableCell>
                  <TableCell sx={{ maxWidth: { xs: 'none', md: 280 }, whiteSpace: { xs: 'normal', md: 'nowrap' }, overflow: 'hidden', textOverflow: 'ellipsis' }}>{e.description || e.notes}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Paper>
    </Box>
  );
}
